'use client'
/***
 *
 * @file components/Box/index.tsx
 * @description Box component will be used for rendering the content.
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 13 Feb 2024
 *
 */

import React, { ReactNode, useEffect, useState } from "react";
// import "./Box.scss";
// import { getStruct } from "./actions";

type T_Props = {
  id?: string,
  children: ReactNode,
  className?: string,
  customStyles?: any
}

/**
 * Description: It takes in children as props and renders them within the html div element inside the Box layout
 * 
 * @param param0 
 * @example Parameter breakup
 * ```
 *  param0: {
 *    children,          //children components to be rendered
 *    className: "",     //className passed via contentful
 *    customStyles: {},  //style object passed via contentful
 *    id: ""             
 *  }
 * ```
 * @example T_Props 
 * ```
 * type T_Props = {
 *     id?: string,           // optional
 *     children: ReactNode,  
 *     className?: string,    //optional
 *     customStyles?: any     //optional
 * }
 * ```
 * @returns an html that renders child components within an html div element as part of a Box component
 */

const Box = ({ children, id, ...props }: T_Props) => {

  return (
    <div id={id || "bx"} className={`bp-box ${props?.className || ''}`} style={{ ...props?.customStyles }} data-testid="Box">
      {children}
    </div>
  );
};

export default Box;
